<template>
	<section id="objetos">
		<Notification ref="notif" :closed="true" corner="bottom-right" />
		<container v-if="renderForPerfil($auth.user().perfil)" textButton="ADICIONAR" :pathName="{ name: 'objetoCreate' }"></container>
		<container v-else></container>

		<div id="main-container">
			<div class="relatorio">
				<router-link :to="{ name: 'importacoesObjetos' }" class="position-left highlight">Importações</router-link>

				<!-- <a v-if="renderForPerfil($auth.user().perfil)" class="relatorio-geral" target="_blank" :href="this.$relatorio.split('/api')[0] + '/relatorios/Geral.xlsx'">
					Relatório Analytics
				</a> -->
				<DropdownMenu name="reportMenu"
					text="Relatório de objetos"
					:loading="generatingReport"
					:tooltip="{
						type: 'warning',
						text: 'Ao exportar o relatório para a realização de alteração de dados, lembre-se de selecionar antes o filtro de tipo'
					}"
					:items="[
						{ text: 'Relatório de objetos sem filtros', handler: function () { objectReport(false) } },
						{ text: 'Relatório de objetos com filtros', handler: function () { objectReport(true) } },
					]"
				/>
			</div>

			<section id="params-container">
				<div id="grid-header"><i class="fas fa-filter"></i>	Filtros:</div>
				<div class="search-section">
					<input id="search" type="text" placeholder="Pesquise por título, descrição, autor, fonte, e propriedades do tipo do objeto" ref="campoparams" v-model.lazy="params.texto"
					@keyup.enter="getObjetos(1)" />
					<label for="search"><i class="fas fa-search"></i></label>
				</div>

				<div class="field" id="codigo">
					<input type="text" v-model="params.codigo" placeholder="Pesquise pelo código do objeto"/>
				</div>

				<v-select id="selectStatus" class="status area_3" v-model="params.status" placeholder="Escolha o status" :reduce="obj => obj.status" label="nome"
					:options="statusObjeto"
				/>

				<v-select id="selectData" class="tipo area_3" v-model="params.tipoData" placeholder="Escolha a data a ser considerada" :reduce="obj => obj.id" label="nome"
					:options="[
						{ id: 1, nome: 'Apenas data de cadastro' },
						{ id: 2, nome: 'Apenas data de atualização' }
					]"
				/>

				<div id="dataInicio" class="calendario-container data">
					<div class="box-date">
						<datepicker class="input-date" :clear-button="true"
						placeholder="Selecione a data inicial" :language="calendarLanguage.ptBR" format="dd/MM/yyyy"
						v-model="params.data"></datepicker>
						<i class="far fa-calendar-alt"></i>
					</div>
				</div>

				<div id="dataFim" class="calendario-container datafim">
					<div class="box-date">
						<datepicker class="input-date" :clear-button="true"
						placeholder="Selecione a data final" :language="calendarLanguage.ptBR" format="dd/MM/yyyy"
						v-model="params.dataFim"></datepicker>
						<i class="far fa-calendar-alt"></i>
					</div>
				</div>

				<v-select
					id="objeto"
					class="tipo area_3"
					v-model="params.tipo"
					placeholder="Escolha o tipo de objeto"
					:options="tipos"
					:reduce="obj => obj.id" label="nome"/>

				<v-select
					id="curador"
					class="usuario area_3"
					v-model="usuario"
					placeholder="Escolha o responsável pelo cadastro"
					@input="userSearch(usuario)"
					:options="curadores"
					:reduce="obj => obj" label="nome"/>

				<v-select
					id="curadoria"
					class="curadoria area_3"
					v-model="params.curadoria"
					placeholder="Escolha a curadoria"
					@input="populaNextSelect({id: params.curadoria, curr: curadorias,  nextName: 'subCuradorias', prop: 'subCuradorias'})"
					:options="curadorias"
					:reduce="obj => obj.id" label="nome"/>

				<v-select
					id="subcuradoria"
					class="subcuradoria area_3"
					v-model="params.subcuradoria"
					:disabled="subcuradoria"
					placeholder="Escolha a sub curadoria"
					@input="populaNextSelect({id: params.subcuradoria, curr: subCuradorias,  nextName: 'eixos', prop: 'subCuradorias'})"
					:options="subCuradorias"
					:reduce="obj => obj.id" label="nome"/>

				<v-select id="eixo"
					class="eixo area_3"
					v-model="params.eixo"
					:disabled="eixo"
					placeholder="Escolha o eixo"
					:options="eixos"
					:reduce="obj => obj.id" label="nome" />

				<div class="acoes">
					<button class="btn" id="limpar" type="button" @click="limparFiltros(), getObjetos(2)">Limpar</button>
					<button class="btn" id="filtrar" type="button" @click="getObjetos(2)">Filtrar</button>
				</div>

			</section>

			<section id="params-container-tag">

				<div class="field" id="tagqa">
					<label for="idtagqa"><i class="fas fa-filter"></i> Tags Q1E:</label>
					<input type="text" id="idtagqa" placeholder="Pesquise as tags desejadas" ref="campoparams" v-model.lazy="params.tagsQa" @keyup.enter="getObjetos(3)"/>
				</div>

				<div class="acoes">
					<button class="btn" id="limpar" type="button" @click="limparFiltros(), getObjetos(3)">Limpar</button>
					<button class="btn" id="filtrar" type="button" @click="getObjetos(3)">Filtrar</button>
				</div>

			</section>

			<load-content v-if="loadContent"/>

			<div class="table-wrapper" v-if="!loadContent && objetos.length > 0">
				<div class="table">
					<table>
						<thead>
							<tr>
								<th id="th-codigo">Código</th>
								<th id="th-nome" class="ordena">Título<!--<i class="fas fa-arrow-up"></i>--></th>
								<th id="th-tipo">Tipo de objeto</th>
								<th id="th-acoes">Ações</th>
							</tr>
						</thead>

						<tbody>
							<tr class="fields" v-for="objeto in objetosEdicaoVerificada" :key="objeto.id">
								<td class="objeto-codigo-amigavel">
									<span class="code-error" v-if="objeto.fullCode.error">{{ objeto.fullCode.msg }}</span>
									<span v-else>{{ objeto.fullCode }}</span>
								</td>
								<td class="objeto-nome"><span>{{ objeto.titulo }}</span></td>
								<td class="objeto-tipo text-overflow" :title="objeto.tipoNome"><span>{{ objeto.tipoNome }}</span></td>
								<td class="acoes">
									<div class="btn-container">
										<span class="copy-id-obj">
											<copiar :button="true" :text="objeto.id" :hideText="true"></copiar>
										</span>
										<span @click="openLink(objeto.urlObjeto)" title="Acessar objeto" class="abrir_objeto fas fa-external-link-alt"></span>
										<item-edit v-if="renderForPerfil($auth.user().perfil)" class="editar acao" :routerName="objeto.editavel  ? 'objetoEdit' : '' " :params="{ id: objeto.id  }" :active="objeto.editavel"/>
										<router-link class="visualizar acao" :to="{ name: 'objetoDetalhes', params: { id: objeto.id }}">
											<i class="far fa-eye"></i>
										</router-link>
										<button-remove v-if="renderForPerfil($auth.user().perfil)" class="acao" :onClick="() => selectHandler(objeto)" :active="objeto.editavel"/>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="paginacao" v-if="totalItens > 20">
					<Pagination :totalItens="totalItens" :currentPage="currentPage" @pagina="getCurrentPage" />
				</div>
			</div>

			<div v-else-if="!loadContent && inicial" class="objectNotFound">
					Nenhum objeto encontrado :)
			</div>

			<!-- Modal para confirmação de exclusão de área de conhecimento -->
			<Modal v-show="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
				<template v-slot:body>
					<p class="texto">Deseja remover o Objeto <i>{{ removeItem.nome }}</i>?</p>
				</template>

				<template v-slot:footer>
					<button-action type="button" :onClick="() => remove(removeItem.id)" class="xs danger" style="margin-right: 10px;">Confirmar</button-action>
					<button-action type="button" :onClick="closeModal" class="xs default">Cancelar</button-action>
				</template>
			</Modal>
			<!-- Final exclusão de área de conhecimento  -->

			<!-- Modal para confirmação de exclusão de área de conhecimento -->

		</div>

	</section>
	</template>

<script>
import { objetos } from '@/services/objetos'
import { tipos } from '@/services/tipos'
import { curadoria } from '@/services/curadoria'
import { usuarios } from '@/services/usuarios'
import { getCode } from '@/helpers/objectCode'

import podeEditar from '@/mixins/podeEditarMixin'

import Datepicker from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import Pagination from '@/components/shared/Pagination'
import container from '@/components/shared/Container'
import LoadContent from '@/components/shared/LoadContent'
import Modal from '@/components/shared/Modal'
import ButtonAction from '@/components/shared/ButtonAction'
import ButtonRemove from '@/components/shared/ButtonRemove'
import ItemEdit from '@/components/shared/ItemEdit'
import Copiar from '@/components/shared/Copiar'
import DropdownMenu from '@/components/shared/DropdownMenu'
import statusObjeto from '@/assets/enum/statusObjeto'

export default {
	name: 'objetosList',
	components: { container, Modal, ButtonAction, ButtonRemove, ItemEdit, Pagination, LoadContent, vSelect, Datepicker, Copiar, DropdownMenu },
	mixins: [podeEditar],
	data () {
		return {
			statusObjeto,
			calendarLanguage: { ptBR },
			objetos: [],
			totalItens: 0,
			currentPage: 1,
			isModalVisible: false,
			removeItem: {},
			params: {
				tipo: '',
				dono: '',
				curadoria: '',
				subcuradoria: '',
				eixo: '',
				tipoData: '',
				data: '',
				dataFim: '',
				teste: '',
				codigo: '',
				status: ''
			},
			isModalVisibleDetalhes: false,
			inicial: false,
			subcuradoria: true,
			eixo: true,
			usuario: '',
			loadContent: false,
			tipos: undefined,
			curadores: [],
			curadorias: [], // TODO Filtrar curadoria de acordo com o curador selecionado ou vice-versa [Seria realmente útil?]
			subCuradorias: [],
			eixos: [],
			generatingReport: false
		}
	},
	async created () {
		// const PERFIL_CURADOR = 2
		// this.inicial = true
		this.params.usuario = this.$auth.user().id
		// this.obterTotal()
		this.getCurrentPage()
		window.addEventListener('keydown', this.focusparams)

		await tipos.findByActive()
			.then(res => {
				this.tipos = res.data
			})
			.catch(err => {
				console.log(err)
			})

		await curadoria.findByActiveInTree()
			.then(res => {
				(this.curadorias = res.data)
			})
			.catch(err => console.log(err))

		await usuarios.findAllObjectsOwners()
			.then(res => {
				if (res.data) this.curadores = res.data
			})
			.catch(err => {
				console.log(err)
			})
	},
	computed: {
		objetosEdicaoVerificada: function () {
			return this.objetos.map(objeto => {
				objeto.editavel = this.podeEditar(objeto)
				objeto.fullCode = getCode(objeto, true)

				return objeto
			})
		}
	},
	methods: {
		async getCurrentPage () {
			this.loadContent = true
			// this.params = {
			// 	...this.$route.query
			// }
			this.params.skip = this.$route.query.skip

			if (this.params && this.params.skip) {
				this.currentPage = parseInt(this.params.skip)
				this.params.skip = parseInt(this.params.skip) - 1
			} else {
				this.currentPage = 1
				this.params.skip = 0
			}

			this.objetos = []

			await objetos.find(this.params)
				.then(res => {
					this.totalItens = res.data[0].totalDeObjetos
					this.objetos = res.data
					this.inicial = true
					return this.objetos
				})
				.catch(err => console.log(err))

			this.loadContent = false
		},
		// async obterTotal () {
		// 	this.loadContent = true
		// 	await objetos.getTotal()
		// 		.then(res => (this.totalItens = res.data.totalDeObjetos))
		// 		.catch(err => console.log(err))
		// 	this.loadContent = false
		// },
		closeModal () {
			this.isModalVisible = false
		},
		selectHandler (data) {
			this.isModalVisible = true
			this.removeItem = data
		},
		async getObjetos (identificador) {
			if (this.params.data && this.params.dataFim && this.params.data > this.params.dataFim) {
				window.notificationEM.open('', 'A data inicial não pode ser menor que a data final', 'warning')
				return
			}

			this.loadContent = true
			this.params.skip = 0
			let retorno = {}
			try {
				if (identificador === 1 && this.params.texto !== undefined) {
					retorno = await objetos.find(this.params)
				}
				if (identificador === 3 && this.params.tagsQa !== undefined) {
					retorno = await objetos.getTagsQa(this.params.tagsQa)
				} else {
					retorno = await objetos.find(this.params)
				}
				if (this.usuario) {
					this.params.dono = this.usuario.id
				}

				this.objetos = retorno.data
				this.totalItens = retorno.data[0].totalDeObjetos
				this.paginaAtual = 1
			} catch (error) {
				console.log('error', error)
			}
			this.loadContent = false
		},
		async remove (id) {
			this.isModalVisible = false
			this.loadContent = true
			try {
				await objetos.delete(id)
				if (parseInt(this.removeItem.totalDeObjetos - 1) % 20 === 0) {
					const query = { skip: this.$route.query.skip - 1 }
					this.$router.replace({ query })
					this.params.skip = this.$route.query.skip > 1 ? this.$route.query.skip - 1 : 0
				}
				const objetosRetorno = await objetos.find(this.params)
				this.objetos = objetosRetorno.data
				if (this.objetos.length) {
					this.totalItens = objetosRetorno.data[0].totalDeObjetos
				}

				// this.objetos = this.objetos.filter(objeto => objeto.id !== id)
				// this.isModalVisible = false
				// this.removeItem = {}
				window.notificationEM.open('', 'Objeto removido com sucesso!', 'success')
			} catch (error) {
				// this.isModalVisible = false
				// this.removeItem = {}
				if (error.response.status === 400) {
					window.notificationEM.open('', `${error.response.data.msg}`, 'error')
				} else {
					window.notificationEM.open('', 'Ocorreu um erro, tente novamente!', 'error')
				}
			}
			this.removeItem = {}
			this.loadContent = false
		},
		focusparams () {
			if (event.keyCode === 13 && event.target.id !== 'search' && this.$refs.campoparams) {
				this.$refs.campoparams.focus()
			}
		},
		async userSearch (user) {
			this.params.dono = ''
			if (user) {
				this.params.dono = user.id
			}
		},
		populaNextSelect (param) {
			if (param.nextName === 'subCuradorias') {
				this.params.subcuradoria = null
				this.params.eixo = null
				if (param.id) {
					this.subcuradoria = false
				} else {
					this.subcuradoria = true
				}
				this.eixo = true
				this.subCuradorias = []
				this.eixos = []
			}
			if (param.nextName === 'eixos') {
				this.eixo = false
				this.params.eixo = this.params.eixo === null ? '' : null
				this.eixos = []
			}
			if (param.id) {
				const obj = param.curr.find(c => c.id === param.id)
				this[param.nextName] = obj[param.prop]
			}
		},
		detalhesObjetos () {
			this.isModalVisibleDetalhes = true
		},
		async objectReport (filter) {
			if (this.params.data && this.params.dataFim && this.params.data > this.params.dataFim) {
				window.notificationEM.open('', 'A data inicial não pode ser menor que a data final', 'warning')
				return
			}

			this.generatingReport = true

			const reportRequest = await objetos.processReport(filter ? this.params : false)
			this.generatingReport = false

			if (reportRequest) {
				location.href = reportRequest.data.arquivo
			}
		},
		openLink (url) {
			return url ? window.open(url) : false
		},
		renderForPerfil (perfil) {
			return [1, 2, 3, 4].find(auth => auth === perfil)
		},
		limparFiltros () {
			let i = 0
			for (i in this.params) {
				this.params[i] = ''
			}

			this.params.skip = 0
			this.params.currentPage = 1
			this.usuario = null
		},
		getCode
	}
}
</script>

	<style lang="scss" scoped>
	#main-container{
		background-color: white;
		margin-top: -50px;
		padding: 10px 20px;
		border-radius: $border-radius;

		#params-container-tag{
			background-color: $main-color;
			border-radius: 4px;
			margin-top: 15px;
			height: 100%;
			width: 100%;

			padding: 5px 10px 10px;

			display: grid;
			grid-template-columns: repeat(3, 1fr);
			grid-template-areas: 	"tagqa tagqa tagqa"
									"empty empty acoes";
			#tagqa{
				grid-area: tagqa;

				label{
					color:white;
					font-size: 0.9rem;
					letter-spacing: 0.04rem;
				}

				input {
					width: 100%;
					height: 45px;
					padding: 16px;
					border: none;
					border-radius: $border-radius;
					background-color: #FFF;
				}
			}

			.acoes {
				grid-area: acoes;
				justify-self: end;
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 5px;
				margin-top: 1rem;

				.btn {
					background-color: $success-color;
					border: none;
					border-radius: 4px;
					outline: none;
					padding: 20px 0;
					line-height: 1px;
					color: #fff;
					font-weight: $font-weight-buttons;
					font-size: $font-size-button;
					font-family: "Roboto",Condensed,sans-serif;
					text-transform: uppercase;
					height: 45px;
					width: 140px;
					cursor: pointer;
					transition: background-color .127s;

					&#limpar {
						background-color: transparent;
						border: 1px solid #FFF;

						&:hover {
							background-color: #FFF2;
						}
					}

					&:hover {
						background-color: #2E5BBD;
					}
				}
			}

			.params-container-row {
				background-color: yellow;
				height: 45px;
			}
		}

		#params-container {
			background-color: $main-color;
			border-radius: 4px;
			margin-top: 15px;
			height: 100%;
			width: 100%;

			padding: 5px 10px 10px;

			display: grid;
			grid-template-columns: repeat(3, 1fr);
			grid-template-areas: "header header header"
													"textTitulo textTitulo codigo "
													"tipoObjeto selectStatus curador"
													"selectData dataInicio dataFim"
													"curadoria subcuradoria eixo"
													"tagqa tagqa tagqa"
													"empty empty acoes";
			align-items: center;
			gap: 10px;

			#grid-header{
				position: relative;
				grid-area: header;
				top: 5px;
				font-family: $font-family;
				font-size: $font-size;
				font-weight: $font-weight-labels;
				color: #FFF;
			}

			.search-section{
				grid-area: textTitulo;
				background-color: #ffffff;
				height: 45px;
				margin-left: 0px;
				margin-top: 0px;
				padding: 16px 16px 16px 10px;

				#search{
					margin-left: 0px;
				}

				label {
					color: #808080;
					i {
						font-weight: 600;
						position: relative;
						top: 1px;
						left: 8px;
					}
				}

			}

			#codigo {
				grid-area: codigo;

				input {
					width: 100%;
					height: 45px;
					padding: 16px;
					border: none;
					border-radius: $border-radius;
					background-color: #FFF;
				}
			}

			#selectData {
				grid-area: selectData;
			}

			#selectStatus {
				grid-area: selectStatus;
			}

			#dataInicio, #dataFim {
				background-color: #ffffff;
				height: 45px;
				border-radius: 5px;
				padding: 0px 5px;
				display: flex;

				&.calendario-container {
					.box-date {
						width: 100%;
						i {
							position: relative;
							top: -35px;
							left: 6px;
							color: gray;
							font-size: 25px;
						}
					}
				}
			}

			#dataInicio {
				grid-area: dataInicio;
			}

			#dataFim {
				grid-area: dataFim;
			}

			.v-select {
				background-color: white;
				border-radius: 4px;
				border:none;
			}

			.vs__fade-enter-active,
			.vs__fade-leave-active {
				transition: none;
			}

			.v-select.area_3{
				height: 45px;
			}

			#objeto{
				grid-area: tipoObjeto;
				width: 100%;
			}

			#curador{
				grid-area: curador;
				width: 100%;
			}

			#curadoria{
				grid-area: curadoria;
				width: 100%;
			}

			#subcuradoria{
				grid-area: subcuradoria;
			}

			#eixo{
				grid-area: eixo;
				height: 45px;
			}

			.acoes {
				grid-area: acoes;
				justify-self: end;
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 5px;

				.btn {
					background-color: $success-color;
					border: none;
					border-radius: 4px;
					outline: none;
					padding: 20px 0;
					line-height: 1px;
					color: #fff;
					font-weight: $font-weight-buttons;
					font-size: $font-size-button;
					font-family: "Roboto",Condensed,sans-serif;
					text-transform: uppercase;
					height: 45px;
					width: 140px;
					cursor: pointer;
					transition: background-color .127s;

					&#limpar {
						background-color: transparent;
						border: 1px solid #FFF;

						&:hover {
							background-color: #FFF2;
						}
					}

					&:hover {
						background-color: #2E5BBD;
					}
				}
			}

			.params-container-row {
				background-color: yellow;
				height: 45px;
			}
		}

		.table-wrapper {
			.table {
				display:flex;
				padding: 5px 0px 0px;
				color: $main-color;
				font-weight: $font-weight-default-bolder;

				thead{
					th{
						&.ordena {
							i {
								margin-left: 5px;
								font-size: 12px;
								font-weight: 600;
							}
						}
					}
				}

				.fields {
					height: 45px;
					background-color: $inputs-color;
					td {
						vertical-align: middle;
						font-size: 0.9em;
						flex-grow: 0;
						color: gray;
						font-weight: 500;

						.code-error {
							font-size: .9em;
							font-weight: bold;

							&::before {
								content: '!';
								display: inline-flex;
								justify-content: center;
								align-items: center;
								width: 26px;
								height: 26px;
								margin-right: 10px;
								border-radius: 50%;
								background-color: #FFBB00;
								color: #FFF;
							}
						}
					}
					.objeto-nome {
						width: 30%;
					}
					.objeto-codigo {
						display: flex;
						.id-obj{
							text-overflow: ellipsis;
							overflow: hidden;
							white-space: nowrap;
						}
						.copy-id-obj{
							position: relative;
							top: 2px;
						}
					}
					.objeto-tipo {
						text-align: center;
						&.text-overflow {
							min-width: 75px;
							max-width: 162px;
							text-align: center;
							text-overflow: ellipsis;
							white-space: nowrap;
							overflow: hidden;
						}
						span {
							background-color: #fff;
							padding: 5px 20px;
							border-radius: 4px;
						}
					}
					.objeto-update {
						text-align: center;
					}
				}
			}
		}

		.objectNotFound {
			margin-top: 50px;
			color: #000;
			text-align: center;
		}
	}
	</style>

	<style lang="scss">
		.vdp-datepicker {
			border:none !important;
			height: 100%;
			width: 100%;
			color: gray;
			div:first-of-type {
				height: 100%;
				input[type=text] {
					width: 100%;
					height: 100%;
					text-align: left;
					border: none;
					font-family: $font-family;
					font-weight: $font-weight-input-bolder;
					font-size: $font-size;
					color: $font-color;
					padding-left: 35px;
					&:focus{
						outline-color: transparent;
					}
				}
			}
			.vdp-datepicker__clear-button {
				position: absolute;
				right: 10px;
				top: 5px;
				i {
					font-size: 30px;
				}
			}
		}
		.vs--searchable .vs__dropdown-toggle {
			height: 100%;
		}
	</style>
